<div class="container-fluid main-container">
  <div class="container-fluid mt-4 card-container">
    <h3 class="benchmarking-plus-txt">{{moduleName}}</h3>
    <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4">
      @for (item of items; track item; let i = $index) {
        <div class="col">
          <div class="card h-100">
            <div class="card-body">
              <h5 class="card-title">{{ item.displayName}}</h5>
              <p class="card-text">{{ item.description }}</p>
            </div>
            <div class="text-center">
              <button type="button" class="btn enter-button" (click)="navigateToHome(item)">Enter</button>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>

